export default "__VITE_ASSET__VAAha8Xz__"